import { render, staticRenderFns } from "./SubGroup.vue?vue&type=template&id=0e765a3e"
import script from "./SubGroup.vue?vue&type=script&lang=js"
export * from "./SubGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e765a3e')) {
      api.createRecord('0e765a3e', component.options)
    } else {
      api.reload('0e765a3e', component.options)
    }
    module.hot.accept("./SubGroup.vue?vue&type=template&id=0e765a3e", function () {
      api.rerender('0e765a3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/group/SubGroup.vue"
export default component.exports